import React from 'react';

import s from './SubscriptionTips.scss';

export interface Props {
  moduleId: number;
}

const SubscriptionTips: React.FC<Props> = props => {
  return <div className={s['root']}>Tips</div>;
};
SubscriptionTips.displayName = 'SubscriptionTips';

export default SubscriptionTips;
